<span *ngFor="let route of transportation?.routes; index as routeIndex">
  <span *ngIf="routeIndex > 0">&nbsp;/&nbsp;</span>
  {{ route.start?.toDate() | date: "dd MMMM" }}
  <span *ngIf="route?.start && (route?.from || route?.to)">
    &mdash;
  </span>
  {{ route?.from }}
  <span *ngIf="route?.from && route?.to"> › </span>{{ route?.to }}
</span>
